import { toast } from 'sonner'

const getContent = ({ header, description, options = {} }) => {
  return [
    header, 
    {
      description: description, 
      ...options,
    }
  ]
}

export const toastSuccess = ({ header, description, options = {} }) => {
  const [message, toastOptions] = getContent({ header, description, options })
  return toast.success(message, {
    duration: 2000,
    ...toastOptions
  })
}

export const toastError = ({ header, description, options = {} }) => {
  const [message, toastOptions] = getContent({ header, description, options })
  return toast.error(message, {
    duration: 2000,
    ...toastOptions
  })
}

export const toastWarning = ({ header, description, options = {} }) => {
  const [message, toastOptions] = getContent({ header, description, options })
  return toast.warning(message, {
    duration: 2000,
    ...toastOptions
  })
}

export const toastInfo = ({ header, description, options = {} }) => {
  const [message, toastOptions] = getContent({ header, description, options })
  return toast.info(message, {
    duration: 2000,
    ...toastOptions
  })
}

export const toastLoading = ({ header, description, options = {} }) => {
  const [message, toastOptions] = getContent({ header, description, options })
  return toast.loading(message, {
    duration: Infinity, 
    ...toastOptions
  })
}

export const updateToast = (toastId, type, { header, description, options = {} }) => {
  toast.dismiss(toastId)
  
  switch (type) {
    case 'success':
      return toastSuccess({ header, description, options })
    case 'error':
      return toastError({ header, description, options })
    case 'warning':
      return toastWarning({ header, description, options })
    case 'info':
      return toastInfo({ header, description, options })
    default:
      const [message, toastOptions] = getContent({ header, description, options })
      return toast(message, toastOptions)
  }
}

export const toastPromise = (promise, { loading, success, error, options = {} }) => {
  return toast.promise(promise, {
    loading: loading || 'Processing...',
    success: success || 'Operation completed successfully!',
    error: error || 'Something went wrong',
    ...options
  })
}

export const toastWithAction = (message, action, options = {}) => {
  return toast(message, {
    action: {
      label: action.label,
      onClick: action.onClick
    },
    duration: 6000,
    ...options
  })
}

export { toast }